import React from 'react'

const useValidationHint = (hasPendingSelection: boolean, isDropdownOpen: boolean) => {
  const [showHint, setShowHint] = React.useState(false)
  const timeoutRef = React.useRef<number | null>(null)

  React.useEffect(() => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }

    if (hasPendingSelection && !isDropdownOpen) {
      timeoutRef.current = window.setTimeout(() => {
        setShowHint(true)
      }, 3000)
    } else {
      setShowHint(false)
    }

    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [hasPendingSelection, isDropdownOpen])

  return [showHint, setShowHint] as const
}

export { useValidationHint }
